export const materialsConstants = {
  GETMATERIALS_REQUEST: 'GETMATERIALS_REQUEST',
  GETMATERIALS_SUCCESS: 'GETMATERIALS_SUCCESS',
  GETMATERIALS_FAILURE: 'GETMATERIALS_FAILURE',
};
